var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/node_modules/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = polyfills